// Website copy — sourced from "Feral Website Copy (2).docx" (AMEND versions applied; strapline "Be Free, Be FERAL.")
export const STRAPLINE = "Be Free, Be FERAL.";
export const STAYS_URL_DEFAULT = "https://feralstays.com";

export const NAV = [
  { label: "Events & Retreats", to: "/events", testid: "nav-link-events" },
  { label: "FERAL Stays", to: "/stays", testid: "nav-link-stays" },
  { label: "Venue Hire", to: "/venue-hire", testid: "nav-link-venue" },
  { label: "UNBOUND", to: "/unbound", testid: "nav-link-unbound" },
  { label: "Our Story", to: "/our-story", testid: "nav-link-story" },
];

export const HERO = {
  headline: STRAPLINE,
  copy: "A collective rooted in nature, wellness and connection. Retreats, festivals, stays and venue hire across three historic estates on the wild edges of Anglesey.",
  ctas: [
    { label: "Upcoming events", to: "/#whats-on" },
    { label: "Plan a retreat", to: "/venue-hire" },
  ],
};

export const EXPERIENCE = {
  heading: "Built on experience. Rooted in nature.",
  paras: [
    "FERAL is a team of retreat, events, hospitality and property specialists, with years of experience delivering everything from intimate wellbeing retreats to large-scale corporate gatherings.",
    "And we don't hire spaces. We own them.",
    "Our three historic estates on Anglesey are home to our events and venue hire, along with a wide choice of holiday cottages and houses to stay in.",
    "We know how much people need time away from screens, schedules and noise: time to ground themselves in nature, reconnect with each other and come back clearer.",
  ],
  stayCta: "Book a FERAL stay",
};

export const PATHWAYS = [
  { key: "events", num: "01", title: "FERAL Fest, Events & Retreats", copy: "Unlock your wildest potential through community, wellness, nature and food.", cta: "Explore events", to: "/events", image: "/home/candle-dinner.webp" },
  { key: "stays", num: "02", title: "FERAL Stays", copy: "Three historic Welsh estates on the wild edges of Anglesey, with cottages and houses for every kind of getaway.", cta: "Book a stay", to: "/stays", image: "/bron-exterior.jpeg" },
  { key: "venue", num: "03", title: "Corporate & Retreat Venue Hire", copy: "Exclusive use of our estates for offsites, retreats and events, planned by a team that knows corporate groups inside out.", cta: "Plan your event", to: "/venue-hire", image: "/home/hottub.webp" },
  { key: "unbound", num: "04", title: "FERAL UNBOUND", copy: "Therapy and coaching for founders, creators and entrepreneurs.", cta: "Explore UNBOUND", to: "/unbound", image: "/home/circle.webp" },
];

export const WHATS_ON = {
  eyebrow: "Coming up",
  heading: "What's on.",
  copy: "From retreats to gatherings and festivals, find your way in.",
  cta: "See all events",
};

export const ANGLESEY = {
  eyebrow: "Why Anglesey",
  heading: "An island made for slowing down.",
  copy: "Wild beaches, ancient woodland and the mountains of Eryri across the water. Close enough for a day, far enough to properly switch off. Anglesey isn't just where we're based. It's part of how FERAL works.",
};

export const FOUNDER = {
  eyebrow: "Founder",
  heading: "Why FERAL exists.",
  copy: "FERAL began with Founder Tom's own journey, and a belief that we all need more time to reconnect with ourselves, each other and the natural world.",
  cta: "Read our story",
};

// Placeholders until real quotes are supplied — do not invent testimonials.
export const TESTIMONIALS = [
  { key: "event-guest", label: "Event guest", quote: "", author: "" },
  { key: "stay-guest", label: "Stay guest", quote: "", author: "" },
  { key: "corporate-client", label: "Corporate client", quote: "", author: "" },
];

export const BREATHWORK = {
  heading: "Take a pause with us.",
  copy: "Get a free 20-minute meditation session with our in-house FERAL Therapeutic Practitioner Calum, straight to your inbox, plus first access to new events and retreats.",
  button: "Send me my session",
};

export const FOOTER = {
  intro: "Keep up to date with everything from FERAL.",
  location: "Anglesey, North Wales",
  email: "hello@feralcollective.co.uk",
  instagram: "https://www.instagram.com/weareferalcollective?mdxt=MTVydWJtNHlibGsx",
  facebook: "https://www.facebook.com/findyourferal.co",
};
